<template>
  <v-container>
    <!-- Diálogo modal Persistente para seleccionar la Caseta -->
    <v-dialog v-model="dialogInitial" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{$t('selecciona_caseta')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form
                    @submit.prevent="setGuardHouse()">
              <v-col cols="12" sm="12">
                <v-autocomplete
                        v-model="guardHouse"
                        name="guardHouse"
                        :items="guardHouses"
                        item-text="name"
                        item-value="id"
                        :label="$t('Casetas')"
                        autocomplete="off"
                ></v-autocomplete>
              </v-col>
              <v-btn
                      color="primary"
                      type="submit"
              >{{ $t('aceptar') }}
              </v-btn>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <h1>{{ $t('Bienvenido') }}: {{getProfile.first_name}} {{getProfile.last_name}}</h1>
    <v-layout align-center justify-center>
      <v-flex>
        <v-card class="elevation-5">
          <v-img
                  v-if="(getProfile.role > 0 && getProfile.role < 5) && getProfile.wallpaper !== null"
                  :src="getProfile.wallpaper"
          ></v-img>
          <v-img
                  v-else
                  :src="require('../assets/home3.jpg')"
          ></v-img>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import axios from 'axios'
import store from '@/store'

export default {
  name: 'home',
  data () {
    return {
      dialogInitial: false,
      guardHouse: null,
      guardHouses: [],
      role: 0,
      bandDevices: true,
      devices: [],
      cams: [],
      qrs: []
    }
  },
  computed: {
    ...mapGetters(['getProfile'])
  },
  created () {
    this.getExtraData()
  },
  methods: {
    getExtraData () {
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/users/me/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.role = response.data.role
          if (this.role === 4) {
            this.getGuardHouse()
            console.log(localStorage.getItem('idGuardHouse'))
            if (localStorage.getItem('idGuardHouse') === null && (localStorage.getItem('permisos') !== null && JSON.parse(localStorage.getItem('permisos')) === true)) {
              this.dialogInitial = true
              // console.log('Dialogo Enfocado')
            } else {
              if (localStorage.getItem('idGuardHouse') === null && (localStorage.getItem('permisos') === null && response.data.idHousingUnit === '898109fd-bb69-4d2f-a223-5457810e2171')) {
                this.dialogInitial = true
              }
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getGuardHouse () {
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/guardhouse/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.guardHouses = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getDevicesByGuardHouse () {
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/guardhouse/' + localStorage.getItem('idGuardHouse') + '/devices/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.devices = response.data
          for (let i = 0; i < this.devices.length; i++) {
            if (this.devices[i].classification === 'qr') {
              this.qrs.push(this.devices[i])
            }
            if (this.devices[i].classification === 'cam') {
              this.cams.push(this.devices[i])
            }
          }
          localStorage.setItem('qr_devices', JSON.stringify(this.qrs))
          this.$store.commit('setQRDevices', JSON.parse(localStorage.getItem('qr_devices')))
          localStorage.setItem('cam_devices', JSON.stringify(this.cams))
          this.$store.commit('setCamDevices', JSON.parse(localStorage.getItem('cam_devices')))
          if (this.qrs.length > 0) {
            this.$store.commit('enableBandQr', true)
            localStorage.setItem('banderaQR', true)
          } else {
            this.$store.commit('enableBandQr', false)
            localStorage.setItem('banderaQR', false)
          }
          if (this.cams.length > 0) {
            localStorage.setItem('banderaAdditionalPerson', false)
            localStorage.setItem('banderaINEBack', false)
            localStorage.setItem('banderaCam', true)
            this.$store.commit('enableBandCam', true)
          } else {
            localStorage.setItem('banderaCam', false)
            this.$store.commit('enableBandCam', false)
          }
          // Iniciar Sesión en Socket
          this.connectToWebSocket()
        })
        .catch(error => {
          console.log(error)
        })
    },
    setGuardHouse () {
      if (this.guardHouse !== null) {
        localStorage.setItem('idGuardHouse', this.guardHouse)
        // Obtenemos Dispositivos de la Caseta (Simulado)
        this.getDevicesByGuardHouse()
        this.dialogInitial = false
      }
    },
    connectToWebSocket () {
      const websocket = new WebSocket('wss://clubtest.intrare.app/ws/socket/devices/' + localStorage.getItem('idGuardHouse') + '/?token=' + store.getters.getToken)
      websocket.onopen = this.onOpen
      websocket.onclose = this.onClose
      websocket.onmessage = this.onMessage
      websocket.onerror = this.onError
    },
    onOpen (event) {
      console.log('Connection opened.', event.data)
    },
    onClose (event) {
      console.log('Connection closed.', event.data)
      // Try and Reconnect after five seconds
      setTimeout(this.connectToWebSocket, 5000)
    },
    onMessage (event) {
      const message = JSON.parse(event.data)
      switch (message.classification) {
        case 'qr':
          const config = {
            method: 'get',
            url: 'https://clubtest.intrare.app/vigilant/qr/' + message.data,
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
            }
          }
          axios(config).then(response => {
            switch (response.data.type_code) {
              case 0: // Invitation
                const config2 = {
                  method: 'get',
                  url: 'https://clubtest.intrare.app/Access/Get/ByCode/' + message.data + '/',
                  headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Token ' + store.getters.getToken
                  }
                }
                axios(config2).then(response2 => {
                  var aux = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
                  var item = message
                  console.log(response2.data)
                  if (response.data.invitation.typeInv === 0) { // Tipo de Invitación Normal
                    if (response2.data.length > 0 && response2.data[0].dateTime_EntranceAccess != null && response2.data[0].dateTime_ExitAccess != null) {
                      // alert('Ya se completó el acceso con la invitación Correspondiente.')
                      // this.head_color = 'orange display-1 text--primary'
                      // this.errores_guard = this.$t('mensaje_acceso_completo')
                      // this.dialog_errores = true
                      console.log('COMPLETO')
                      var fullItem = Object.assign(item, { 'status': 1 })
                      console.log(fullItem)
                      aux.push(fullItem)
                      localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                      this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                    } else {
                      if (response2.data.length > 0) {
                        // this.entrada = false
                        // this.salida = true
                        // this.dialog = true
                        // this.activar_camara = false
                        console.log('SALIDA')
                        var fullItem2 = Object.assign(item, { 'status': 3 })
                        var fullItem3 = Object.assign(fullItem2, { 'info': response.data })
                        var fullItemAccess = Object.assign(fullItem3, { 'access': response2.data[0].id })
                        console.log(fullItemAccess)
                        aux.push(fullItemAccess)
                        localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                        this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                      } else {
                        var fechaLocal1 = new Date(this.get_current_date())
                        const readableDate = response.data.invitation.dateInv.substring(3, 6) + response.data.invitation.dateInv.substring(0, 2) + response.data.invitation.dateInv.substring(5, 10)
                        var fechaAccesoEntrada1 = new Date(readableDate)
                        if (fechaAccesoEntrada1.getTime() !== fechaLocal1.getTime()) {
                          console.log('Fuera de FECHA')
                          var fullItem17 = Object.assign(item, { 'status': 4 })
                          console.log(fullItem17)
                          aux.push(fullItem17)
                          localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                          this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                        } else {
                          console.log('ENTRADA')
                          if (response.data.invitation.temporalToken === '') {
                            var fullItem4 = Object.assign(item, { 'status': 2 })
                            var fullItem5 = Object.assign(fullItem4, { 'info': response.data })
                            console.log(fullItem5)
                            aux.push(fullItem5)
                            localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                            this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                          } else {
                            localStorage.setItem('qr_code_temporal', message.data)
                            localStorage.setItem('host_IdFront', response.data.invitation.hostIdFront)
                            localStorage.setItem('host_avatar', response.data.invitation.avatarHost)
                            localStorage.setItem('host_first_name', response.data.invitation.hostFirstName)
                            localStorage.setItem('host_last_name', response.data.invitation.hostLastName)
                            localStorage.setItem('host_cellphone', response.data.invitation.hostCellphone)
                            localStorage.setItem('host_street', response.data.invitation.street)
                            localStorage.setItem('host_number_house', response.data.invitation.numberHouse)
                            localStorage.setItem('host_supplier', response.data.invitation.supplier)
                            localStorage.setItem('vacation_mode', response.data.invitation.vacation_mode)
                            localStorage.setItem('allow_access_visitors', response.data.invitation.allow_access_visitors)
                            this.$router.push('/booth_registration/' + response.data.invitation.temporalToken)
                          }
                        }
                      }
                    }
                  }
                  if (response.data.invitation.typeInv === 1) { // Tipo de Invitación Pre registro en Caseta
                    if (response2.data.length > 0 && response2.data[0].dateTime_EntranceAccess != null && response2.data[0].dateTime_ExitAccess != null) {
                      // alert('Ya se completó el acceso con la invitación Correspondiente.')
                      // this.head_color = 'orange display-1 text--primary'
                      // this.errores_guard = this.$t('mensaje_acceso_completo')
                      // this.dialog_errores = true
                      console.log('COMPLETO')
                      var fullItem44 = Object.assign(item, { 'status': 1 })
                      console.log(fullItem44)
                      aux.push(fullItem44)
                      localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                      this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                    } else {
                      if (response2.data.length > 0) {
                        // this.entrada = false
                        // this.salida = true
                        // this.dialog = true
                        // this.activar_camara = false
                        console.log('SALIDA')
                        var fullItem222 = Object.assign(item, { 'status': 3 })
                        var fullItem333 = Object.assign(fullItem222, { 'info': response.data })
                        var fullItemAccess0 = Object.assign(fullItem333, { 'access': response2.data[0].id })
                        console.log(fullItemAccess0)
                        aux.push(fullItemAccess0)
                        localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                        this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                      } else {
                        var fechaLocal111 = new Date(this.get_current_date())
                        const readableDate = response.data.invitation.dateInv.substring(3, 6) + response.data.invitation.dateInv.substring(0, 2) + response.data.invitation.dateInv.substring(5, 10)
                        var fechaAccesoEntrada111 = new Date(readableDate)
                        if (fechaAccesoEntrada111.getTime() !== fechaLocal111.getTime()) {
                          console.log('Fuera de FECHA')
                          var fullItem177 = Object.assign(item, { 'status': 4 })
                          console.log(fullItem177)
                          aux.push(fullItem177)
                          localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                          this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                        } else {
                          console.log('ENTRADA')
                          if (response.data.invitation.temporalToken === '') {
                            var fullItem41 = Object.assign(item, { 'status': 2 })
                            var fullItem51 = Object.assign(fullItem41, { 'info': response.data })
                            console.log(fullItem51)
                            aux.push(fullItem51)
                            localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                            this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                          } else {
                            localStorage.setItem('qr_code_temporal', message.data)
                            localStorage.setItem('host_IdFront', response.data.invitation.hostIdFront)
                            localStorage.setItem('host_avatar', response.data.invitation.avatarHost)
                            localStorage.setItem('host_first_name', response.data.invitation.hostFirstName)
                            localStorage.setItem('host_last_name', response.data.invitation.hostLastName)
                            localStorage.setItem('host_cellphone', response.data.invitation.hostCellphone)
                            localStorage.setItem('host_street', response.data.invitation.street)
                            localStorage.setItem('host_number_house', response.data.invitation.numberHouse)
                            localStorage.setItem('host_supplier', response.data.invitation.supplier)
                            localStorage.setItem('vacation_mode', response.data.invitation.vacation_mode)
                            localStorage.setItem('allow_access_visitors', response.data.invitation.allow_access_visitors)
                            this.$router.push('/booth_registration/' + response.data.invitation.temporalToken)
                          }
                        }
                      }
                    }
                  }
                  if (response.data.invitation.typeInv === 2) { // Tipo de invitacion recurrente
                    if (response2.data.length === 0) {
                      var fechaLocal2 = new Date(this.get_current_date())
                      const readableDate = response.data.invitation.expiration.substring(3, 6) + response.data.invitation.expiration.substring(0, 2) + response.data.invitation.expiration.substring(5, 10)
                      var fechaExpiracion = new Date(readableDate)
                      console.log('FECHA DE EXPIRACION = ', fechaExpiracion.getTime())
                      console.log('FECHA ACTUAL = ', fechaLocal2)
                      console.log('FECHA DE EXPIRACION = ', response.data.invitation.expiration)
                      console.log('FECHA ACTUAL = ', fechaLocal2.getTime())
                      console.log('Día Actual = ', fechaLocal2.getDay())
                      console.log('Día Expiración = ', fechaExpiracion.getDay())
                      if (fechaLocal2.getDay() !== fechaExpiracion.getDay()) {
                        console.log('Día Diferente a la invitación recurrente.')
                      }
                      // if (fechaAccesoEntrada2.getTime() > fechaLocal2.getTime()) {
                      //   console.log('FECHA DE EXPIRACION > ACTUAL')
                      // }
                      // if (fechaAccesoEntrada2.getTime() < fechaLocal2.getTime()) {
                      //   console.log('FECHA DE EXPIRACION < ACTUAL')
                      // }
                      // if (fechaAccesoEntrada2.getTime() === fechaLocal2.getTime()) {
                      //   console.log('FECHA DE EXPIRACION = ACTUAL')
                      // }
                      if (fechaLocal2.getTime() > fechaExpiracion.getTime()) {
                        console.log('Expirada')
                        var fullItem18 = Object.assign(item, { 'status': 5 })
                        console.log(fullItem18)
                        aux.push(fullItem18)
                        localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                        this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                      } else {
                        var dias = response.data.invitation.diary
                        var diasJS = ['6', '0', '1', '2', '3', '4', '5']
                        console.log(dias)
                        console.log('Dia = ', diasJS[fechaLocal2.getDay()])
                        if (dias.includes(diasJS[fechaLocal2.getDay()]) === false) {
                          console.log('Día inválido')
                          var fullItem19 = Object.assign(item, { 'status': 6 })
                          console.log(fullItem19)
                          aux.push(fullItem19)
                          localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                          this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                        } else {
                          console.log('ENTRADA RECURRENTE')
                          if (response.data.invitation.temporalToken === '') {
                            var fullItem6 = Object.assign(item, { 'status': 2 })
                            var fullItem7 = Object.assign(fullItem6, { 'info': response.data })
                            console.log(fullItem7)
                            aux.push(fullItem7)
                            localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                            this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                          } else {
                            localStorage.setItem('qr_code_temporal', message.data)
                            localStorage.setItem('host_IdFront', response.data.invitation.hostIdFront)
                            localStorage.setItem('host_avatar', response.data.invitation.avatarHost)
                            localStorage.setItem('host_first_name', response.data.invitation.hostFirstName)
                            localStorage.setItem('host_last_name', response.data.invitation.hostLastName)
                            localStorage.setItem('host_cellphone', response.data.invitation.hostCellphone)
                            localStorage.setItem('host_street', response.data.invitation.street)
                            localStorage.setItem('host_number_house', response.data.invitation.numberHouse)
                            localStorage.setItem('host_supplier', response.data.invitation.supplier)
                            localStorage.setItem('vacation_mode', response.data.invitation.vacation_mode)
                            localStorage.setItem('allow_access_visitors', response.data.invitation.allow_access_visitors)
                            this.$router.push('/booth_registration/' + response.data.invitation.temporalToken)
                          }
                        }
                      }
                    } else {
                      if (response2.data[0].status === 1) {
                        // this.entrada = false
                        // this.salida = true
                        // this.dialog = true
                        // this.activar_camara = false
                        console.log('SALIDA RECURRENTE', response2.data[0])
                        var fullItem8 = Object.assign(item, { 'status': 3 })
                        var fullItem9 = Object.assign(fullItem8, { 'info': response.data })
                        var fullItemAccess2 = Object.assign(fullItem9, { 'access': response2.data[0].id })
                        console.log(fullItemAccess2)
                        aux.push(fullItemAccess2)
                        localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                        this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                      } else {
                        var fechaLocal = new Date(this.get_current_date())
                        const readableDate = response2.data[0].dateTime_EntranceAccess.substring(3, 6) + response2.data[0].dateTime_EntranceAccess.substring(0, 2) + response2.data[0].dateTime_EntranceAccess.substring(5, 10)
                        const expirationDate = response.data.invitation.expiration.substring(3, 6) + response.data.invitation.expiration.substring(0, 2) + response.data.invitation.expiration.substring(5, 10)
                        var fechaAccesoEntrada = new Date(readableDate)
                        var expirationDate2 = new Date(expirationDate)
                        console.log('FECHA DE EXPIRACION = ', expirationDate2.getTime())
                        console.log('FECHA ACTUAL = ', fechaLocal)
                        console.log('FECHA DE EXPIRACION = ', response.data.invitation.expiration)
                        console.log('FECHA ACTUAL = ', fechaLocal.getTime())
                        console.log('Día Actual = ', fechaLocal.getDay())
                        console.log('Día Expiración = ', expirationDate2.getDay())
                        if (fechaLocal.getDay() !== expirationDate2.getDay()) {
                          console.log('Día Diferente a la invitación recurrente.')
                        }
                        if (fechaAccesoEntrada.getTime() !== fechaLocal.getTime()) {
                          if (fechaLocal.getTime() > expirationDate2.getTime()) {
                            console.log('Expirada')
                            var fullItem20 = Object.assign(item, { 'status': 5 })
                            console.log(fullItem20)
                            aux.push(fullItem20)
                            localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                            this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                          } else {
                            dias = response.data.invitation.diary
                            diasJS = ['6', '0', '1', '2', '3', '4', '5']
                            console.log(dias)
                            console.log('Dia = ', diasJS[fechaLocal.getDay()])
                            if (dias.includes(diasJS[fechaLocal.getDay()]) === false) {
                              console.log('Día inválido')
                              var fullItem21 = Object.assign(item, { 'status': 6 })
                              console.log(fullItem21)
                              aux.push(fullItem21)
                              localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                              this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                            } else {
                              console.log('ENTRADA RECURRENTE')
                              var fullItem22 = Object.assign(item, { 'status': 2 })
                              var fullItem23 = Object.assign(fullItem22, { 'info': response.data })
                              console.log(fullItem23)
                              aux.push(fullItem23)
                              localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                              this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                            }
                          }
                        } else {
                          // this.clear_without_activate_camera()
                          // this.head_color = 'orange display-1 text--primary'
                          // this.errores_guard = this.$t('mensaje_acceso_completo')
                          // this.dialog_errores = true
                          console.log('COMPLETO RECURRENTE')
                          var fullItem10 = Object.assign(item, { 'status': 1 })
                          var fullItem11 = Object.assign(fullItem10, { 'info': response.data })
                          console.log(fullItem11)
                          aux.push(fullItem11)
                          localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                          this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                        }
                      }
                    }
                  }
                }).catch(error => {
                  console.log(error)
                })
                break
              case 1: // Residente
                console.log('Residente')
                var aux = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
                var item = message
                var fullItem13 = Object.assign(item, { 'info': response.data })
                var fullItem14 = Object.assign(fullItem13, { 'status': -1 })
                console.log(fullItem14)
                aux.push(fullItem14)
                localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                break
              case 2: // Worker
                const config3 = {
                  method: 'post',
                  url: 'https://clubtest.intrare.app/WorkerAccess/Status/',
                  headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Token ' + store.getters.getToken
                  },
                  data: {
                    'qr_code': message.data
                  }
                }
                axios(config3)
                  .then(response3 => {
                    console.log(response3.data.status)
                    var aux = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
                    var item = message
                    switch (response3.data.status) {
                      case 10:
                        var fullItem15 = Object.assign(item, { 'info': response.data })
                        var fullItem16 = Object.assign(fullItem15, { 'status': 10 })
                        console.log(fullItem16)
                        aux.push(fullItem16)
                        localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                        this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                        break
                      case 11:
                        var fullItem17 = Object.assign(item, { 'info': response.data })
                        var fullItem18 = Object.assign(fullItem17, { 'status': 11 })
                        console.log(fullItem18)
                        aux.push(fullItem18)
                        localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                        this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                        break
                      case 12:
                        var fullItem19 = Object.assign(item, { 'status': 12 })
                        console.log(fullItem19)
                        aux.push(fullItem19)
                        localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                        this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                        break
                      case 13:
                        var fullItem20 = Object.assign(item, { 'status': 13 })
                        console.log(fullItem20)
                        aux.push(fullItem20)
                        localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                        this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                        break
                    }
                  })
                  .catch(error => {
                    console.log(error)
                  })
                break
            }
          }).catch(error => {
            console.log(error)
            if (error.request.status === 404) {
              console.log('NO Valido')
              var aux = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
              var item = message
              var fullItem12 = Object.assign(item, { 'status': 0 })
              console.log(fullItem12)
              aux.push(fullItem12)
              localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
              this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
            }
            if (error.request.status === 401) {
              console.log('Invitacion Expirada')
              var listQrCodesAux = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
              var itemAux = message
              var fullItemAux = Object.assign(itemAux, { 'status': 5 })
              console.log(fullItemAux)
              listQrCodesAux.push(fullItemAux)
              localStorage.setItem('listStoreQrCodes', JSON.stringify(listQrCodesAux))
              this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
            }
            if (error.request.status === 403) {
              console.log('Invitacion Cancelada')
              var listQrCodesAux2 = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
              var itemAux2 = message
              var fullItemAux2 = Object.assign(itemAux2, { 'status': -3 })
              console.log(fullItemAux2)
              listQrCodesAux2.push(fullItemAux2)
              localStorage.setItem('listStoreQrCodes', JSON.stringify(listQrCodesAux2))
              this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
            }
            if (error.request.status === 423) {
              console.log('Modo Vacaciones Aactivado')
              var listQrCodesAux3 = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
              var itemAux3 = message
              var fullItemAux3 = Object.assign(itemAux3, { 'status': -5 })
              console.log(fullItemAux3)
              listQrCodesAux3.push(fullItemAux3)
              localStorage.setItem('listStoreQrCodes', JSON.stringify(listQrCodesAux3))
              this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
            }
          })
          if (localStorage.getItem('qr_devices') !== null) {
            console.log('Dato recivido de QR')
            let band = false
            let devicesAux = JSON.parse(localStorage.getItem('qr_devices'))
            console.log('Auxiluar = ', devicesAux)
            for (let i = 0; !band && i < devicesAux.length; i++) {
              if (devicesAux[i].label === message.label) {
                console.log(devicesAux[i].label, '===', message.label)
                devicesAux[i] = Object.assign(devicesAux[i], { 'data': message.data })
                localStorage.setItem('qr_devices', JSON.stringify(devicesAux))
                this.$store.commit('setQRDevices', JSON.parse(localStorage.getItem('qr_devices')))
                band = true
              }
            }
            console.log(JSON.parse(localStorage.getItem('qr_devices')))
          }
          break
        case 'cam':
          if (localStorage.getItem('banderaAdditionalPerson') !== null || localStorage.getItem('banderaINEBack') !== null) {
            console.log('banderaAdditionalPerson', localStorage.getItem('banderaAdditionalPerson'))
            console.log('banderaINEBack', localStorage.getItem('banderaINEBack'))
            if (localStorage.getItem('banderaAdditionalPerson') === 'true') {
              console.log('Foto Additional Person')
              var auxAdditional = localStorage.getItem('listStorePhotosCameraAdditionalPerson') === null ? [] : JSON.parse(localStorage.getItem('listStorePhotosCameraAdditionalPerson'))
              while (auxAdditional.length > 0) {
                auxAdditional.pop()
              }
              auxAdditional.push(message)
              localStorage.setItem('listStorePhotosCameraAdditionalPerson', JSON.stringify(auxAdditional))
              this.$store.commit('setPhotosAdditionalPerson', JSON.parse(localStorage.getItem('listStorePhotosCameraAdditionalPerson')))
              if (localStorage.getItem('cam_devices') !== null) {
                console.log('Dato recivido de CAM')
                let band = false
                let devicesAux = JSON.parse(localStorage.getItem('cam_devices'))
                console.log('Auxiluar = ', devicesAux)
                for (let i = 0; !band && i < devicesAux.length; i++) {
                  if (devicesAux[i].label === message.label) {
                    console.log(devicesAux[i].label, '===', message.label)
                    devicesAux[i] = Object.assign(devicesAux[i], { 'data': message.data })
                    localStorage.setItem('cam_devices', JSON.stringify(devicesAux))
                    this.$store.commit('setCamDevices', JSON.parse(localStorage.getItem('cam_devices')))
                    band = true
                  }
                }
                console.log(JSON.parse(localStorage.getItem('cam_devices')))
              }
            } else {
              if (localStorage.getItem('banderaINEBack') === 'true') {
                console.log('Foto INE Back')
                var auxAdditional2 = localStorage.getItem('listStorePhotosCameraINEBack') === null ? [] : JSON.parse(localStorage.getItem('listStorePhotosCameraINEBack'))
                while (auxAdditional2.length > 0) {
                  auxAdditional2.pop()
                }
                auxAdditional2.push(message)
                localStorage.setItem('listStorePhotosCameraINEBack', JSON.stringify(auxAdditional2))
                this.$store.commit('setPhotosINEBack', JSON.parse(localStorage.getItem('listStorePhotosCameraINEBack')))
                if (localStorage.getItem('cam_devices') !== null) {
                  console.log('Dato recivido de CAM')
                  let band = false
                  let devicesAux = JSON.parse(localStorage.getItem('cam_devices'))
                  console.log('Auxiluar = ', devicesAux)
                  for (let i = 0; !band && i < devicesAux.length; i++) {
                    if (devicesAux[i].label === message.label) {
                      console.log(devicesAux[i].label, '===', message.label)
                      devicesAux[i] = Object.assign(devicesAux[i], { 'data': message.data })
                      localStorage.setItem('cam_devices', JSON.stringify(devicesAux))
                      this.$store.commit('setCamDevices', JSON.parse(localStorage.getItem('cam_devices')))
                      band = true
                    }
                  }
                  console.log(JSON.parse(localStorage.getItem('cam_devices')))
                }
              } else {
                console.log('Foto Normal')
                var aux = localStorage.getItem('listStorePhotosCamera') === null ? [] : JSON.parse(localStorage.getItem('listStorePhotosCamera'))
                while (aux.length > 0) {
                  aux.pop()
                }
                aux.push(message)
                localStorage.setItem('listStorePhotosCamera', JSON.stringify(aux))
                this.$store.commit('setPhotos', JSON.parse(localStorage.getItem('listStorePhotosCamera')))
                if (localStorage.getItem('cam_devices') !== null) {
                  console.log('Dato recivido de CAM')
                  let band = false
                  let devicesAux = JSON.parse(localStorage.getItem('cam_devices'))
                  console.log('Auxiluar = ', devicesAux)
                  for (let i = 0; !band && i < devicesAux.length; i++) {
                    if (devicesAux[i].label === message.label) {
                      console.log(devicesAux[i].label, '===', message.label)
                      devicesAux[i] = Object.assign(devicesAux[i], { 'data': message.data })
                      localStorage.setItem('cam_devices', JSON.stringify(devicesAux))
                      this.$store.commit('setCamDevices', JSON.parse(localStorage.getItem('cam_devices')))
                      band = true
                    }
                  }
                  console.log(JSON.parse(localStorage.getItem('cam_devices')))
                }
              }
            }
          }
          break
      }
      console.log('Dato Recivido: ', message)
    },
    onError (event) {
      console.log('An error occured:', event.data)
    },
    get_current_date () {
      var today = new Date()
      var dd = today.getDate()
      var mm = today.getMonth() + 1
      var yyyy = today.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      today = mm + '/' + dd + '/' + yyyy
      return today
    }
  }
}
</script>
